
const clamp = function(el){
    const show = function(e){
        console.log(e.target);
        el.classList.remove('js-clamp');
        el.removeEventListener('click', show);
    }
    el.addEventListener('click', show);
}

export {clamp};